function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M42,42c0,1.657-1.343,3-3,3c-1.125,0-2.125-0.5-2.75-1.75"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M47 42A2 2 0 1 0 47 46 2 2 0 1 0 47 42zM29.5 4A4.5 4.5 0 1 0 29.5 13 4.5 4.5 0 1 0 29.5 4zM37.144 42.8l-4.906-9.743c-.288.221-.598.418-.941.567-.284.123-.576.216-.874.279l4.934 9.798c.176.349.528.55.895.55.151 0 .305-.034.449-.106C37.193 43.895 37.392 43.294 37.144 42.8zM31.792 28.5l-6.564-14.128C25.063 13.942 24.143 12 21.125 12c-1.132 0-2.358.384-3.592 1-.57.285-1.26.746-1.664 1.021-1.95 1.324-4.537 3.546-7.54 7.179-.143.173-.442.531-.445.535-.336.45-.647.998-.794 1.721C7.032 23.734 7 24.039 7 24.375c0 1.864 1.25 3.5 3.25 5 .016.012 1.662 1.273 2.669 1.954C13.562 31.764 18 34.8 18 34.8V43c0 1.657 1.343 3 3 3 1.53 0 2.792-1.145 2.977-2.625C23.992 43.252 24 43.127 24 43v-9.5c0-.829-.343-1.621-.948-2.188l-7.096-6.652c2.9-3.044 4.879-4.272 5.794-4.659l5.458 10.496c.409.94 1.327 1.502 2.292 1.502.333 0 .673-.066.998-.208C31.439 31.381 32 30.463 32 29.498 32 29.165 31.934 28.825 31.792 28.5z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.798,32.986c-0.932-0.631-2.339-1.698-2.748-2.011c-0.812-0.609-1.484-1.23-2.05-1.863v4.775l-5.413,7.33c-0.37,0.501-0.561,1.079-0.585,1.657c-0.039,0.961,0.383,1.924,1.215,2.538C2.754,45.81,3.379,46,3.998,46c0.919,0,1.827-0.421,2.415-1.218l6-8.125C12.794,36.141,13,35.517,13,34.875l0-1.07C12.43,33.415,11.973,33.104,11.798,32.986z"
});

function SvgFieldHockey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldHockey);
export default __webpack_public_path__ + "static/media/field-hockey.180ec7df.svg";
export { ForwardRef as ReactComponent };